import { styled } from 'styled-components';
import { Checkbox } from 'antd';

export const EachColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .ant-form-item {
    padding-left: 16px;

    &.full-width {
      width: 100%;
    }
  }
`;

export const FormSection = styled.div`
  display: flex;
`;

export const EachRow = styled.div`
  display: flex;
`;

export const PermissionsCheckboxWrap = styled(Checkbox.Group)`
  display: flex;

  label {
    margin: 1rem 0;
  }
`;
